import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BudgetBox from "../components/BudgetBox";
import { useQuery } from "react-query";
import { getBudget } from "../api/budget";

export default function ManageBudget() {
  const dateStore = useSelector((state) => state.date);
  const [state, setState] = useState({
    items: JSON.parse(localStorage.getItem("budgets")),
    types: JSON.parse(localStorage.getItem("types")),
    loading: false,
  });

  const { isLoading, error, data } = useQuery({
    queryKey: ["getBudget", dateStore.year, dateStore.month],
    queryFn: async () => await getBudget(dateStore.year, dateStore.month),
    enabled: !!dateStore.year && !!dateStore.month,
  });

  let listEl = [];
  if (state.types && state.types.length > 0) {
    let accountList = [];
    accountList.push(
      <BudgetBox
        type={5}
        list={data?.filter((t) => t.TYPE === 5)}
        title={state.types[4].NAME}
        titleClassName="bg-sky-100"
        edit={true}
      />
    );
    for (var i = 1; i <= 4; i++) {
      accountList.push(
        <BudgetBox
          type={i}
          list={data?.filter((t) => t.TYPE === i)}
          title={state.types[i - 1].NAME}
          edit={true}
        />
      );
    }
    listEl.push(accountList);
  } else {
    listEl.push(<div>None</div>);
  }

  return (
    <section>
      ManageBudget
      <div className="flex">
        <span>{dateStore.year}년</span>
        <span className="pl-1">{dateStore.month}월</span>
        <span className="pl-1">예산안</span>
      </div>
      <div className="sm:grid sm:grid-cols-2">{listEl}</div>
    </section>
  );
}
